import { APP_PATH } from '../../appConfig';
import React from 'react'
import './style.css'
const path = APP_PATH
const MoreApps = () => <iframe title='Apps' className="iframe" src={`https://shipping.logiceverest.com/moreapps/${path}`} frameborder="0"></iframe>
export default MoreApps